export default __webpack_public_path__ + "static/media/DEL_SEC_RGB.ae03e885.png";